// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
            <g fill="none" fillRule="evenodd">
                <rect width="31" height="31" x=".5" y=".5" stroke="currentColor" rx="2" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M23.268 12.336a1.906 1.906 0 0 0-1.34-1.35c-1.184-.319-5.928-.319-5.928-.319s-4.744 0-5.927.32a1.906 1.906 0 0 0-1.341 1.349c-.317 1.19-.317 3.675-.317 3.675s0 2.484.317 3.675a1.878 1.878 0 0 0 1.341 1.329c1.183.319 5.927.319 5.927.319s4.744 0 5.927-.32a1.878 1.878 0 0 0 1.341-1.328c.317-1.19.317-3.675.317-3.675s0-2.484-.317-3.675Zm-8.82 5.93v-4.51l3.966 2.255-3.965 2.256Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(Youtube);
